import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URL } from './api-base';

@Injectable({ providedIn: 'root' })
export class MoodService {
  private apiUrl = `${API_BASE_URL}/moods`;

  constructor(private http: HttpClient) {}

  recordMood(payload: { user_id: number; tenant_id: number; mood: string; notes?: string }): Observable<any> {
    return this.http.post(this.apiUrl, payload);
  }

  getTodayMood(userId: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/today`, { params: { user_id: userId } });
  }

  getSummary(tenantId: number, userId: number, days = 30): Observable<{
    period_days: number;
    start_date: string;
    total_responses: number;
    moods: Array<{ mood: string; count: number; percent: number }>;
  }> {
    return this.http.get<{
      period_days: number;
      start_date: string;
      total_responses: number;
      moods: Array<{ mood: string; count: number; percent: number }>;
    }>(`${this.apiUrl}/summary`, { params: { tenant_id: tenantId, user_id: userId, days } });
  }

  getScopedAnalytics(tenantId: number, userIds: number[], months = 3, departmentIds: number[] = []): Observable<{
    period_months: number;
    start_date: string;
    total_responses: number;
    unique_respondents: number;
    moods: Array<{ mood: string; label: string; count: number; percent: number }>;
    monthly: Array<{ month_key: string; label: string; count: number; unique_respondents: number }>;
    by_gender: Array<{ key: string; label: string; count: number; percent: number }>;
    by_department: Array<{
      label: string;
      count: number;
      percent: number;
      positive_count: number;
      neutral_count: number;
      negative_count: number;
    }>;
  }> {
    const userIdsToken = (userIds || []).filter((id) => Number.isFinite(id) && Number(id) > 0).join(',');
    const departmentIdsToken = (departmentIds || []).filter((id) => Number.isFinite(id) && Number(id) > 0).join(',');
    return this.http.get<{
      period_months: number;
      start_date: string;
      total_responses: number;
      unique_respondents: number;
      moods: Array<{ mood: string; label: string; count: number; percent: number }>;
      monthly: Array<{ month_key: string; label: string; count: number; unique_respondents: number }>;
      by_gender: Array<{ key: string; label: string; count: number; percent: number }>;
      by_department: Array<{
        label: string;
        count: number;
        percent: number;
        positive_count: number;
        neutral_count: number;
        negative_count: number;
      }>;
    }>(`${this.apiUrl}/scoped-analytics`, {
      params: {
        tenant_id: String(tenantId),
        months: String(months),
        user_ids: userIdsToken,
        department_ids: departmentIdsToken
      }
    });
  }
}
